/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Card_TitleInputs */

const en_admin_dashboard_card_title = /** @type {(inputs: Admin_Dashboard_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Dashboard`)
};

const de_admin_dashboard_card_title = /** @type {(inputs: Admin_Dashboard_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Dashboard`)
};

/**
* | output |
* | --- |
* | "Admin Dashboard" |
*
* @param {Admin_Dashboard_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_dashboard_card_title = /** @type {((inputs?: Admin_Dashboard_Card_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Card_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_dashboard_card_title(inputs)
	return en_admin_dashboard_card_title(inputs)
});